module.exports = [
    {
        id: 1,
        label: "国家技术发明奖",
    },
    {
        id: 2,
        label: "国家科学技术进步奖",
    },
    {
        id: 3,
        label: "国家自然科学奖",
    },
    {
        id: 4,
        label: "信创工委会-会员单位",
    },
    {
        id: 5,
        label: "高新技术企业",
    },
    {
        id: 6,
        label: "天津市高新技术企业",
    },
    {
        id: 7,
        label: "中关村金种子企业",
    },
    {
        id: 8,
        label: "天津-高新技术企业",
    },
    {
        id: 9,
        label: "创客北京2020防疫大赛全国50强",
    },
    {
        id: 10,
        label: "2020最具成长性新基建创业公司",
    },
    {
        id: 11,
        label: "2019年度最具成长性企业",
    },
    {
        id: 12,
        label: "中国创新创业优秀企业",
    },
    {
        id: 13,
        label: "ISO9001质量管理体系认证证书",
    },
    {
        id: 14,
        label: "知识产权认证",
    },
    {
        id: 15,
        label: "十佳瞪羚企业",
    },
    {
        id: 16,
        label: "卓越创新奖",
    },
    {
        id: 17,
        label: "创新创业大赛二等奖",
    },
    {
        id: 18,
        label: "生物识别产业技术创新战略联盟",
    },
    {
        id: 19,
        label: "智慧警务优秀创新案例",
    },
    {
        id: 20,
        label: "最具影响力品牌企业",
    },
];
